//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      photoUrl: this.$store.state.userInfo.headphoto,
      show: false,
      show2: false,
      id: this.$route.query.id,
      patient: {}, //患者基本信息
      ordermaintellinfo: {}, //主诉信息
      isAccordingexchanges: [], //舌照面照
      isInterrogationsingle: {}, //问诊单
      otherdetails: [],
      reorderinquiryquestion:[],
    };
  },
  methods: {
    //获取问诊资料详情
    getDiseaseInfo() {
      let params = {
        //1获取2不获取
        orderID: this.id, //订单id
        getPatient: 1, //患者信息
        isaction: 1, //主诉信息
        isAccordingexchanges: 1, //舌照面照
        ischecked: 1, //问诊单
        isInterrogationsingle:1,
      };
      var _this = this;
      this.$doRequest("/api/Inquiry/orderDetails", params, res => {
        this.patient = res.patient;
        this.ordermaintellinfo = res.ordermaintellinfo;
        if(res.accordingTtongue.length>0){
            for(var i=0;i<res.accordingTtongue.length;i++){
                _this.isAccordingexchanges.push(res.accordingTtongue[i]);
            }
        }
        if(res.surfaceAccording.length>0){
            for(var i=0;i<res.surfaceAccording.length;i++){
                _this.isAccordingexchanges.push(res.surfaceAccording[i]);
            }
        }
        _this.otherdetails = res.otherdetails; //其他照片
        _this.reorderinquiryquestion = res.reorderinquiryquestion;
      });
    }

    //详情页跳转
  },
  created: function() {
    this.$isLogin(window.location.search.substr(1), this.getDiseaseInfo);
    document.title = '问诊资料';
  }
};



// WEBPACK FOOTER //
// ./src/views/myDiseaseInfo/index.vue